import React, { Fragment, useEffect } from 'react';
import { IQuestionProps, TemplateType, VIEW_MODE, QuestionOperateType } from '../../../../interface/multiCapabilityTemplate';
import { CapabilityQuestionInfo } from './enterpriseTemplate';
import { lang } from '@umu/ukit-lang';
import { onCheckSetUp } from './dataFlow';
import { ScoreRange, IScoreRangeInfo } from '../scoreRange';
import { AdvanceOption } from '../radioOptionInfo/advanceOption';
import { CapabilityProgressScore } from './capabilityScore';
const preCls = 'template-question';
const NumberQuestion = (props: IQuestionProps) => {
    const { info, mode, templateType, weights = '', isValid, onCommunication } = props;
    const isEnterprise = templateType === TemplateType.ENTERPRISE;
    const [dataInfo, setDataInfo] = React.useState<IScoreRangeInfo>({
        startValue: String(info.extend?.setup?.number_min) || '',
        startLabel: String(info.extend?.setup?.number_min_tag || ''),
        numberDefault: String(info.extend?.setup?.number_default) || '',
        endValue: String(info.extend?.setup?.number_max) || '',
        endLabel: String(info.extend?.setup?.number_max_tag || ''),
    });
    const isView = mode === VIEW_MODE.VIEW;
    const onCapabilityQuestionInfoChange = (data: any) => {
        onCommunication(QuestionOperateType.CHANGE_CONFIG, {
            ...props.info,
            ...data,
        });
    };
    const onAdvanceChange = (data: any) => {
        const extend = props.info?.extend;
        const setup = {
            require: '0',
        };
        setup.require = data.isRequire;
        onCommunication(QuestionOperateType.CHANGE_CONFIG, {
            ...props.info,
            extend: { ...extend, setup: { ...extend?.setup, ...setup } },
        });
    };
    useEffect(() => {
        const extend = props.info?.extend;
        const setup = onCheckSetUp({
            number_min: dataInfo.startValue,
            number_min_tag: dataInfo.startLabel,
            number_default: dataInfo.numberDefault,
            number_max: dataInfo.endValue,
            number_max_tag: dataInfo.endLabel,
        } as any);
        onCommunication(QuestionOperateType.CHANGE_CONFIG, {
            ...props.info,
            extend: { ...extend, setup: { ...extend?.setup, ...setup } },
        });
    }, [dataInfo]);
    const renderAdvanceContent = () => {
        const extend = props.info?.extend;
        const setup: any = extend?.setup || {};
        const advanceInfo: any = {
            isRequire: String(setup?.require || 0),
            defaultValue: setup?.default_value || '',
            optionCount: 10,
        };
        return (
            <AdvanceOption
                isShowDefaultValue
                isView={isView}
                multiple={false}
                info={advanceInfo}
                onChange={onAdvanceChange}
            />
        );
    };

    const renderContent = () => {
        const contentEle = isView ? (
            <CapabilityProgressScore
                mode={VIEW_MODE.VIEW}
                min={Number(info?.extend?.setup.number_min) || 0}
                minTag={info?.extend?.setup.number_min_tag || ''}
                max={Number(info?.extend?.setup.number_max) || 1}
                maxTag={info?.extend?.setup.number_max_tag || ''}
            />
        ) : (
            <ScoreRange
                info={dataInfo}
                onChange={(key, value) => {
                    setDataInfo({
                        ...dataInfo,
                        [key]: value,
                    });
                }}
            />
        );
        return <div className="template-question-content">{contentEle}</div>;
    };
    return (
        <div className={`template-question-number question-number-${templateType}`}>
            {isEnterprise ? (
                <CapabilityQuestionInfo
                    info={info}
                    mode={mode}
                    isValid={isValid}
                    indexPrefix={`Q${info.index}.`}
                    indexSuffix={`${lang('（')}${lang('数值型')}${lang('，')}${lang('权重')}${weights}${lang('）')}`}
                    onChange={(data) => onCapabilityQuestionInfoChange(data)}
                />
            ) : (
                <Fragment>
                    {renderContent()}
                    <div className={`${preCls}-option-advance`}>{renderAdvanceContent()}</div>
                </Fragment>
            )}
        </div>
    );
};
export { NumberQuestion };
